import classNames from "classnames";
import { generateImageUrl } from "@/utils";
import Image from "next/image";
import Link from "next/link";
import { CaretSvg } from "../atoms/CaretSvg";
import { Box } from "../atoms/Box";
import { trackItemTapped } from "@/utils/mixpanel";

const AVATAR_SIZE = 28;

import { Inter } from "next/font/google";
import { MixpanelValues } from "@/constants/mixpanel";

const inter = Inter({ subsets: ["latin"] });

export const GlutenFreeUserReview = ({
    userName,
    userAvatarId,
    reviewText,
    linkToReview,
    position,
    pageTitle,
    isMobile,
}) => {
    if (!reviewText) {
        return null;
    }
    
    return (
        <Box>
            <div id="tt-all-reviews-button">
                <div
                    className="flex justify-between mb-2"
                    id="tt-all-reviews-button">
                    <div className="flex items-center gap-3">
                        <div className="rounded-full overflow-hidden flex items-center justify-center">
                            <Image
                                width={AVATAR_SIZE}
                                id="tt-all-reviews-button"
                                height={AVATAR_SIZE}
                                alt="Profile Image"
                                src={generateImageUrl({
                                    imageId: userAvatarId,
                                    height: AVATAR_SIZE,
                                    width: AVATAR_SIZE,
                                    reason: "topten-secondary-profile",
                                })}
                            />
                        </div>
                        <span
                            id="tt-all-reviews-button"
                            className="font-bold text-ellipsis overflow-hidden whitespace-nowrap w-fit max-w-40">
                            {userName}
                        </span>
                    </div>
                    
                    <Link
                        href={linkToReview || ""}
                        target="_blank">
                        <button
                            data-page-name={pageTitle}
                            data-position={position}
                            data-element-text="Google review"
                            data-device={isMobile ? "mobile" : "desktop"}
                            aria-label="Google review"
                            className={classNames({
                                "text-[13px] leading-tight tracking-tight": true,
                                "text-slate-400 h-8 py-2 rounded-xl": true,
                            })}>
                            <div
                                id="tt-all-reviews-button"
                                className="flex items-center gap-1">
                                <span>Google review</span>
                                <CaretSvg
                                    size={16}
                                    color="#94a3b8"
                                />
                            </div>
                        </button>
                    </Link>
                </div>
                <p
                    onClick={() => trackItemTapped(MixpanelValues.ItemTapped.REVIEW_TEXT)}
                    className={classNames(
                        inter.className,
                        "text-[15px] md:text-lg font-medium leading-snug"
                    )}>
                    {reviewText}
                </p>
            </div>
        </Box>
    );
};
